import React from "react"
import FakeVideosContent from "@assets/images/FakeVideosContent"
import { RFValue } from "react-native-responsive-fontsize"

const fakeQuestions = {
    quizzId: 1,
    title: "Diétique et nutritions : comprendre les bases de la diététique",
    quizzType: 2,
    questions: [
        {
            questionId: 1,
            textQuestion: "Quel est le rôle essentiel des glucides dans l’organisme ?",
            responseType: "checkbox",
            responses: [
                {
                    id: 1,
                    textResponse: "Energétique",
                    isTrue: false
                },
                {
                    id: 2,
                    textResponse: "Favorable à la croissance",
                    isTrue: true
                },
                {
                    id: 3,
                    textResponse: "Indispensable à la constitution",
                    isTrue: false
                }
            ]
        },
        {
            questionId: 2,
            textQuestion: "Actuellement, pratiquez-vous une activité physique ?",
            responseType: "radio",
            responses: [
                {
                    id: 4,
                    textResponse: "Oui",
                    isTrue: false
                },
                {
                    id: 5,
                    textResponse: "Non",
                    isTrue: false
                }
            ]
        },
        {
            questionId: 3,
            textQuestion: "Décrivez votre niveau de fatigue après les activités",
            responseType: "text",
            responses: [
                {
                    id: 6,
                    textResponse: null,
                    isTrue: false
                }
            ]
        }
    ]
}

const references = [
    {
        type: "book",
        title: "Livres",
        data: [
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            },
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            },
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            }
        ]
    },
    {
        type: "article",
        title: "Articles",
        data: [
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            },
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            },
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            }
        ]
    },
    {
        type: "these",
        title: "Thèses de doctorat",
        data: [
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            },
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            },
            {
                content:
                    "42. Supper I, Ecochard R, Bois C, Paumier F, Bez N, Letrilliart L. Comment les généralistes envisagent-ils de participer à la recherche dans leur spécialité? Exercer.2011;22(95):2."
            }
        ]
    }
]

const videos = [
    {
        id: 1,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        videoContent: <FakeVideosContent width={"100%"} height={RFValue(100)} />,
        disabled: false,
        details: {
            intro: "La santé passe par l’assiette ! De nombreux travaux montrent l’impact de facteurs nutritionnels sur la survenue de certaines maladies et a contrario, d’autres études prouvent l’intérêt de certains aliments, nutriments et comportements en prévention de pathologies. Par conséquent, la nutrition est un élément clé pour maintenir voire améliorer notre niveau de santé.",
            author: "Alison Danis",
            date: "Le 19 novembre 2020, à 16h47",
            description: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.

            Il existe 20 acides aminés différents dont 12 sont synthétisés par notre organisme et dont 8 sont dits « indispensables », c’est-à-dire qu’ils doivent être apportés par l’alimentation car nous ne sommes pas capables de les synthétiser.
            
            Les protéines en quantité suffisante contribuent à maintenir et augmenter la masse musculaire mais jouent également un rôle pour le maintien d’une ossature normale.
            
            Pour 1 gramme de protéines consommées, ce sont 4 Calories apportées à l’organisme.`,
            summary: {
                label: "Qui sont les macronutriments ?",
                content: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.`
            }
        }
    },
    {
        id: 2,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        videoContent: <FakeVideosContent width={"100%"} height={RFValue(100)} />,
        disabled: false,
        details: {
            intro: "La santé passe par l’assiette ! De nombreux travaux montrent l’impact de facteurs nutritionnels sur la survenue de certaines maladies et a contrario, d’autres études prouvent l’intérêt de certains aliments, nutriments et comportements en prévention de pathologies. Par conséquent, la nutrition est un élément clé pour maintenir voire améliorer notre niveau de santé.",
            author: "Alison Danis",
            date: "Le 19 novembre 2020, à 16h47",
            description: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.

            Il existe 20 acides aminés différents dont 12 sont synthétisés par notre organisme et dont 8 sont dits « indispensables », c’est-à-dire qu’ils doivent être apportés par l’alimentation car nous ne sommes pas capables de les synthétiser.
            
            Les protéines en quantité suffisante contribuent à maintenir et augmenter la masse musculaire mais jouent également un rôle pour le maintien d’une ossature normale.
            
            Pour 1 gramme de protéines consommées, ce sont 4 Calories apportées à l’organisme.`,
            summary: {
                label: "Qui sont les macronutriments ?",
                content: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.`
            }
        }
    },
    {
        id: 3,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        videoContent: <FakeVideosContent width={"100%"} height={RFValue(100)} />,
        disabled: true,
        details: {
            intro: "La santé passe par l’assiette ! De nombreux travaux montrent l’impact de facteurs nutritionnels sur la survenue de certaines maladies et a contrario, d’autres études prouvent l’intérêt de certains aliments, nutriments et comportements en prévention de pathologies. Par conséquent, la nutrition est un élément clé pour maintenir voire améliorer notre niveau de santé.",
            author: "Alison Danis",
            date: "Le 19 novembre 2020, à 16h47",
            description: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.

            Il existe 20 acides aminés différents dont 12 sont synthétisés par notre organisme et dont 8 sont dits « indispensables », c’est-à-dire qu’ils doivent être apportés par l’alimentation car nous ne sommes pas capables de les synthétiser.
            
            Les protéines en quantité suffisante contribuent à maintenir et augmenter la masse musculaire mais jouent également un rôle pour le maintien d’une ossature normale.
            
            Pour 1 gramme de protéines consommées, ce sont 4 Calories apportées à l’organisme.`,
            summary: {
                label: "Qui sont les macronutriments ?",
                content: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.`
            }
        }
    },
    {
        id: 4,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        videoContent: <FakeVideosContent width={"100%"} height={RFValue(100)} />,
        disabled: false,
        details: {
            intro: "La santé passe par l’assiette ! De nombreux travaux montrent l’impact de facteurs nutritionnels sur la survenue de certaines maladies et a contrario, d’autres études prouvent l’intérêt de certains aliments, nutriments et comportements en prévention de pathologies. Par conséquent, la nutrition est un élément clé pour maintenir voire améliorer notre niveau de santé.",
            author: "Alison Danis",
            date: "Le 19 novembre 2020, à 16h47",
            description: `  Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.

            Il existe 20 acides aminés différents dont 12 sont synthétisés par notre organisme et dont 8 sont dits « indispensables », c’est-à-dire qu’ils doivent être apportés par l’alimentation car nous ne sommes pas capables de les synthétiser.
            
            Les protéines en quantité suffisante contribuent à maintenir et augmenter la masse musculaire mais jouent également un rôle pour le maintien d’une ossature normale.
            
            Pour 1 gramme de protéines consommées, ce sont 4 Calories apportées à l’organisme.`,
            summary: {
                label: "Qui sont les macronutriments ?",
                content: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.`
            }
        }
    },

    {
        id: 5,
        title: "L’équilibre alimentaire gagnant",
        videoContent: <FakeVideosContent width={"100%"} height={RFValue(100)} />,
        disabled: true,
        details: {
            intro: "La santé passe par l’assiette ! De nombreux travaux montrent l’impact de facteurs nutritionnels sur la survenue de certaines maladies et a contrario, d’autres études prouvent l’intérêt de certains aliments, nutriments et comportements en prévention de pathologies. Par conséquent, la nutrition est un élément clé pour maintenir voire améliorer notre niveau de santé.",
            author: "Alison Danis",
            date: "Le 19 novembre 2020, à 16h47",
            description: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.

            Il existe 20 acides aminés différents dont 12 sont synthétisés par notre organisme et dont 8 sont dits « indispensables », c’est-à-dire qu’ils doivent être apportés par l’alimentation car nous ne sommes pas capables de les synthétiser.
            
            Les protéines en quantité suffisante contribuent à maintenir et augmenter la masse musculaire mais jouent également un rôle pour le maintien d’une ossature normale.
            
            Pour 1 gramme de protéines consommées, ce sont 4 Calories apportées à l’organisme.`,
            summary: {
                label: "Qui sont les macronutriments ?",
                content: `Les protides, souvent appelés protéines par abus de langage, sont essentiels au bon fonctionnement de notre métabolisme. Les protides regroupent les protéines, acides aminés et peptides : les acides aminés combinés forment les peptides et l’enchainement de ces peptides forment les protéines. Les protides sont alors des macromolécules, formés d’une ou plusieurs chaines polypeptidiques.`
            }
        }
    }
]

const evaluations = [
    {
        id: 1,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        subContent: {
            title: "Démarrer le quiz"
        }
    },
    {
        id: 2,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        subContent: {
            title: "Voir les résultats"
        }
    },
    {
        id: 3,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        subContent: {
            title: "Démarrer le quiz"
        }
    },
    {
        id: 4,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        subContent: {
            title: "Voir les résultats"
        }
    },

    {
        id: 5,
        title: "L’équilibre alimentaire gagnant",
        subContent: {
            title: "Démarrer le quiz"
        }
    }
]

const temporaryTopicsData = [
    {
        id: 1,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        subContent: {
            title: "Démarrer le quiz",
            messages: 10
        }
    },
    {
        id: 2,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        subContent: {
            title: "Voir les résultats",
            messages: 9
        }
    },
    {
        id: 3,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        subContent: {
            title: "Démarrer le quiz",
            messages: 7
        }
    },
    {
        id: 4,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        subContent: {
            title: "Voir les résultats",
            messages: 15
        }
    },

    {
        id: 5,
        title: "L’équilibre alimentaire gagnant",
        subContent: {
            title: "Démarrer le quiz",
            messages: 20
        }
    }
]

const topicsCategories = [
    {
        id: 1,
        category: "apa",
        label: "APA"
    },

    {
        id: 2,
        category: "dietetic",
        label: "diététique"
    },
    {
        id: 3,
        category: "psychological",
        label: "psychologie"
    },
    {
        id: 4,
        category: "medical",
        label: "médicaux"
    }
]

const ateliers = [
    {
        id: 1,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        subContent: {
            title: "Suivre le direct"
        }
    },
    {
        id: 2,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        subContent: {
            title: "S'inscrire á l'atelier"
        }
    },
    {
        id: 3,
        title: "Diététique et nutrition : comprendre les bases de la diététique",
        subContent: {
            title: "Suivre le direct"
        }
    },
    {
        id: 4,
        title: "Fruits et légumes : pourquoi on nous conseille d’en manger 5 par jour ?",
        subContent: {
            title: "S'inscrire á l'atelier"
        }
    },

    {
        id: 5,
        title: "L’équilibre alimentaire gagnant",
        subContent: {
            title: "Suivre le direct"
        }
    }
]

const topicMessages = [
    {
        id: 1,
        post: "Tu as déjà pratiqué du sport ? De façon régulière ? Ton but est de simplement te maintenir en bonne santé ? Moi je te conseillerais de faire des petites exercices pendant 15 minutes pour d’augmenter. Tu peux aussi essayer de marcher tous les jours !",
        user: {
            fullName: "User 1",
            postedAt: "le 19/11/20 à 13h12"
        }
    },
    {
        id: 2,
        post: "Tu as déjà pratiqué du sport ? De façon régulière ? Ton but est de simplement te maintenir en bonne santé ? Moi je te conseillerais de faire des petites exercices pendant 15 minutes pour d’augmenter. Tu peux aussi essayer de marcher tous les jours !",
        user: {
            fullName: "User Fo",
            postedAt: "le 10/11/20 à 13h12"
        }
    },
    {
        id: 3,
        post: "Tu as déjà pratiqué du sport ? De façon régulière ? Ton but est de simplement te maintenir en bonne santé ? Moi je te conseillerais de faire des petites exercices pendant 15 minutes pour d’augmenter. Tu peux aussi essayer de marcher tous les jours !",
        user: {
            fullName: "User Golum",
            postedAt: "le 05/11/20 à 13h12"
        }
    },
    {
        id: 4,
        post: "Tu as déjà pratiqué du sport ? De façon régulière ? Ton but est de simplement te maintenir en bonne santé ? Moi je te conseillerais de faire des petites exercices pendant 15 minutes pour d’augmenter. Tu peux aussi essayer de marcher tous les jours !",
        user: {
            fullName: "User Fatal",
            postedAt: "le 20/10/20 à 13h12"
        }
    }
]

export {
    references,
    videos,
    evaluations,
    temporaryTopicsData,
    topicsCategories,
    ateliers,
    topicMessages,
    fakeQuestions
}
